/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import CheckIcon from "@/src/assets/icons/common/toggleable/IconCheck";
import CrossIcon from "@/src/assets/icons/common/toggleable/IconClose";
import { dateFieldDefault, pastOrSameDateDefault, requiredValidator } from "@/src/services/validationRules";
import { useForm } from "@/src/provider/Form/FormProvider";
import Group from "@/src/components/Wizard/Group";
import ValidatorDateField from "@/src/components/FormFields/ValidatorDateField";
import { translate } from "@/src/services/translations/translations";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

type BaseEnforceClaimProps = {
  product: AbstractCase;
};

const BaseEnforceClaim = ({ product }: BaseEnforceClaimProps) => {
  const { values } = useForm();

  return (
    <>
      <Grid size={12}>
        <Group
          type="radio"
          name="hasReceivedAdministrativeDecision"
          question="Haben Sie bereits einen Bescheid erhalten?"
          options={[
            {
              labelText: "Ja, ich habe bereits einen Bescheid erhalten.",
              labelIcon: <CheckIcon />,
              labelIconActive: <CheckIcon active />,
              value: "yes",
            },
            {
              labelText: "Nein, ich habe bisher noch keinen Bescheid erhalten.",
              labelIcon: <CrossIcon />,
              labelIconActive: <CrossIcon active />,
              value: "no",
            },
          ]}
          validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
        />
      </Grid>
      {values.hasReceivedAdministrativeDecision === "yes" && (
        <>
          <Grid size={12}>
            <ValidatorDateField
              name="administrativeDecisionReceivedDate"
              label={translate(`${product.name}.administrativeDecisionReceivedDate.label`, values)}
              validators={[
                requiredValidator(translate(`${product.name}.administrativeDecisionReceivedDate.validators.required`, values)),
                dateFieldDefault,
                pastOrSameDateDefault,
              ]}
            />
          </Grid>
          <Group
            type="radio"
            name="hasFiledObjectionToAdministrativeDecision"
            question="Haben Sie bereits Widerspruch gegen den Bescheid eingelegt?"
            options={[
              {
                labelText: "Ja, ich habe bereits Widerspruch gegen den Bescheid eingelegt.",
                labelIcon: <CheckIcon />,
                labelIconActive: <CheckIcon active />,
                value: "yes",
              },
              {
                labelText: "Nein, ich habe bisher keinen Widerspruch gegen den Bescheid eingelegt.",
                labelIcon: <CrossIcon />,
                labelIconActive: <CrossIcon active />,
                value: "no",
              },
            ]}
            validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
          />
          {values.hasFiledObjectionToAdministrativeDecision === "yes" && (
            <Grid size={12}>
              <ValidatorDateField
                name="extrajudicialCommunicationSent"
                label={translate(`${product.name}.extrajudicialCommunicationSent.label`, values)}
                validators={[
                  requiredValidator(translate(`${product.name}.extrajudicialCommunicationSent.validators.required`, values)),
                  dateFieldDefault,
                  pastOrSameDateDefault,
                ]}
              />
            </Grid>
          )}
        </>
      )}
    </>
  );
};
export default BaseEnforceClaim;
